import React, { useEffect } from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import SkillsSection from '@/components/SkillsSection';
import Services from '@/components/Services';
import Experiences from '@/components/Experiences';
import WorksSection from '@/components/WorksSection';
import Education from '@/components/Education';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import BackgroundAudio from '@/components/BackgroundAudio';
import { useAnimations } from '@/lib/animation';

const Index = () => {
  useAnimations();

  return (
    <div className="min-h-screen bg-background">
      <BackgroundAudio />
      <Header />
      <HeroSection />
      <AboutSection />
      <SkillsSection />
      <Services />
      <Experiences />
      <WorksSection />
      <Education />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
